import React, { Component } from "react";
import { LoginFxn } from "./../../actions";
import SimpleReactValidator from "simple-react-validator";
import GoogleLogin from "react-google-login";
import { LINKEDIN_WEB_LOGIN_URL } from ".";
import { firebaseLogin, firebaseSignup } from "../../firebase/firebaseActions";
import authService from "../../services/authService";

class GuestUser extends Component {
    constructor(props) {
        super(props);
        this.state = {
            email: "",
            user_password: "",
            name: "",
            member: false,
            guest: true,
            password: "",
            __btnClicked: false,
            accessState: "",
        };
        this.validator = new SimpleReactValidator();
    }

    componentDidMount() {
        const {__Mounting,__GuestAlreadyExistsHandler} = this.props 
        if(localStorage?.getItem("type") === "Guest" && authService.getUserDetail()?.email){ 
            __GuestAlreadyExistsHandler();
            __Mounting();
        }
        this.setState({ accessState: randomString(15, "aA#") });
        $(".loader-page").addClass("hide");
    }

    componentWillUnmount() {
        $(".loader-page").removeClass("hide");
    }

    onChangeHandler = (e) => {
        const { guest } = this.state;
        let otherStates = guest
            ? { email: "", user_password: "" }
            : { name: "" };
        this.setState({ [e.target.name]: e.target.value, ...otherStates });
    };

    onSubmitHandler = async () => {
        const { member, user_password, email, name } = this.state;
        const { __Mounting } = this.props;
        const GiveStatus = (response) => {
            swal({
                title: response,
                icon: "error",
                buttons: true,
                dangerMode: true,
            });
        };
        this.setState({ __btnClicked: true });
        let responseFirst = await LoginFxn(
            member
                ? {
                      email,
                      password: user_password,
                      request_from: "web",
                      token: false,
                  }
                : { name }
        );
        if (responseFirst.ResponseCode === "1") {
            if (member) {
                let data = JSON.stringify(responseFirst.data);
                await firebaseLogin({
                    email,
                    password: responseFirst?.data?.password,
                });
                localStorage.setItem("data", data);
                localStorage.setItem("token", responseFirst.token);
            } else {
                const email = autoGeneratedGuestEmail(name);
                const password = autoGeneratedGuestPassword();
                await firebaseSignup({ email, password }); 
                localStorage.setItem("token", "");
                localStorage.setItem("type", "Guest");
                localStorage.setItem(
                    "data",
                    JSON.stringify({
                        firstname: name,
                        lastname: "",
                        email,
                        uniquecode: responseFirst.data.firebaseID,
                    })
                );
            }
            __Mounting();
            return;
        } else if (responseFirst.ResponseCode === "0") {
            this.setState({ __btnClicked: false });
            return GiveStatus(responseFirst.ResponseText);
        }
    };

    _facebookLogin = () => {
        FB.getLoginStatus((response) => {
            if (response.status == "connected") {
                this.getCurrentFacebookUserInfo(response);
            } else {
                FB.login(
                    (response) => {
                        if (response.authResponse) {
                            this.getCurrentFacebookUserInfo(response);
                        }
                    },
                    { scope: "email" }
                );
            }
        });
    };

    getCurrentFacebookUserInfo = () => {
        FB.api("/me?fields=id,email,name", async (userInfo) => {
            let email = userInfo?.email;
            if (email) {
                APP.store.dispatch(NavigateToPage("login"));
                const data = {
                    email,
                    request_from: "web",
                    social: "Y",
                    token: true,
                };
                const response = await LoginFxn(data);
                if (response.ResponseCode === "1") {
                    const { __Mounting } = this.props;
                    __Mounting();
                } else {
                    swal({
                        title: "Error!",
                        text: response.ResponseText,
                        icon: "error",
                    });
                }
            }
            if (!userInfo && userInfo.name) {
                FB.logout((response) => {
                    // Person is now logged out
                });
            }
        });
    };

    responseGoogle = async (data) => {
        let email = data?.profileObj?.email;
        if (email) {
            const data = {
                email,
                request_from: "web",
                social: "Y",
                token: true,
            };
            const response = await LoginFxn(data);
            if (response.ResponseCode === "1") {
                const { __Mounting } = this.props;
                __Mounting();
            } else {
                swal({
                    title: "Error!",
                    text: response.ResponseText,
                    icon: "error",
                });
            }
        }
    };

    render() {
        // prettier-ignore
        const { host_name } = this.props;
        const {
            email,
            user_password,
            name,
            member,
            guest,
            __btnClicked, 
        } = this.state;
        this.validator.purgeFields();
        return (
            <div className="guestuser-page-section">
                <div className="container">
                    <a className="guest-user-logo">
                        <img
                            src="public/assets/images/homepagelogo.png"
                            alt="logo"
                        />
                    </a>
                    <h1 className="">Join Meeting</h1>
                    <h3 className="">Join Host @{host_name} in Meeting Room</h3>
                    <div className="guest-user-boxes">
                        <div className="row">
                            <div className="col-md-6">
                                <div className="guest-user-img">
                                    <img
                                        src="public/assets/images/guest-user-img.png"
                                        alt="1"
                                        className="img-fluid"
                                    />
                                    <p>
                                        Need a solution to manage Calls,
                                        <br /> Meetings all in a singe app
                                    </p>
                                    <a className="get-nxa-now">
                                        Get Nxatel Now
                                        <i class="fas fa-arrow-circle-right ml-2"></i>
                                    </a>
                                </div>
                            </div>
                            <div className="col-md-2"></div>
                            <div className="col-md-4">
                                <div className=" guest-user-join-form">
                                    {member && (
                                        <>
                                            <div className="form-group mb-3 mb-1">
                                                <input
                                                    type="text"
                                                    className="form-control "
                                                    placeholder="Enter your email"
                                                    name="email"
                                                    value={email}
                                                    onChange={
                                                        this.onChangeHandler
                                                    }
                                                />
                                                {this.validator.message(
                                                    "member email",
                                                    email,
                                                    "required|email"
                                                )}
                                            </div>
                                            <div className="form-group mb-3 mb-1">
                                                <input
                                                    type="password"
                                                    className="form-control "
                                                    placeholder="Enter Password"
                                                    name="user_password"
                                                    value={user_password}
                                                    onChange={
                                                        this.onChangeHandler
                                                    }
                                                />
                                                {this.validator.message(
                                                    "member password",
                                                    user_password,
                                                    "required"
                                                )}
                                            </div>
                                        </>
                                    )}
                                    {guest && (
                                        <div className="form-group mb-3 mb-1">
                                            <input
                                                type="text"
                                                className="form-control "
                                                placeholder="Enter your name"
                                                name="name"
                                                value={name}
                                                onChange={this.onChangeHandler}
                                            />
                                            {this.validator.message(
                                                "guest Name",
                                                name,
                                                "required"
                                            )}
                                        </div>
                                    )}
                                    <div className="d-flex justify-content-center guest-user-join-btn-div">
                                        <button
                                            type="button"
                                            className="btn btn-new-sign bg-back mr-3"
                                            onClick={(e) => {
                                                window.close();
                                            }}
                                            disabled={__btnClicked}
                                        >
                                            Back
                                        </button>
                                        <button
                                            type="button"
                                            className="btn btn-new-sign"
                                            onClick={(e) =>
                                                __btnClicked
                                                    ? e.preventDefault()
                                                    : this.onSubmitHandler()
                                            }
                                        >
                                            {" "}
                                            {__btnClicked
                                                ? "Please wait..."
                                                : "Join"}
                                        </button>
                                    </div>
                                    <h5>
                                        Or Join Meeting on Mobile, Download our
                                        App
                                    </h5>
                                    <div className="d-flex guest-user-app-dwn-ico justify-content-center">
                                        <a>
                                            <img
                                                src="public/assets/images/Icons App Store Google play 1.png"
                                                alt="1"
                                            />
                                        </a>
                                        <a>
                                            <img
                                                src="public/assets/images/Icons App Store Google play 3.png"
                                                alt="1"
                                            />
                                        </a>
                                    </div>
                                    <h6>
                                        {guest
                                            ? "Already have a Nxatel Account"
                                            : "Join as Guest"}
                                    </h6>
                                    <div className="d-flex justify-content-center">
                                        <button
                                            type="button"
                                            className="btn btn-new-sign"
                                            onClick={() =>
                                                this.setState({
                                                    guest: !guest,
                                                    member: !member,
                                                })
                                            }
                                        >
                                            {guest
                                                ? "Sign in"
                                                : "Login as Guest"}
                                        </button>
                                    </div>
                                    <div className="d-flex login-with-icons justify-content-center">
                                        <a
                                            href={void 0}
                                            className="webphone-btns"
                                            onClick={this._facebookLogin}
                                        >
                                            <img
                                                src="public/assets/images/signup/facebook.png"
                                                alt="1"
                                            />
                                        </a>
                                        <GoogleLogin
                                            clientId={REACT_APP_GOOGLE_APP_ID}
                                            render={(renderProps) => (
                                                <a
                                                    onClick={
                                                        renderProps.onClick
                                                    }
                                                    disabled={
                                                        renderProps.disabled
                                                    }
                                                    className="webphone-btns"
                                                >
                                                    <img
                                                        src="public/assets/images/signup/google.png"
                                                        alt="1"
                                                    />
                                                </a>
                                            )}
                                            onSuccess={this.responseGoogle}
                                            onFailure={this.responseGoogle}
                                            cookiePolicy={"single_host_origin"}
                                        />
                                        <a
                                            href={LINKEDIN_WEB_LOGIN_URL}
                                            style={{ cursor: "pointer" }}
                                            className="webphone-btns"
                                        >
                                            <img
                                                src="public/assets/images/signup/linkedin.png"
                                                alt="1"
                                                className="webphone-btns"
                                            />
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default GuestUser;
